function isSwetTailor() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('swettailor') !== -1;
}

export default isSwetTailor;
